import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {CommonsDialogService} from "../../services/commons-dialog.service";

export class BringozItemsLinkListComponent implements IController {

  state: string;
  permission: string;
  ids: string[];
  items: { id: string, name?: string, fullName?: string}[];
  maxDisplay: number;

  public viewItems: { id: string, name?: string, fullName?: string }[];
  public extraItems: { id: string, name?: string , fullName?: string }[];

  constructor(private commonsDialogService: CommonsDialogService) {
  }

  $onInit() {

    if (!this.maxDisplay) {
      this.maxDisplay = 1;
    }

    this._initData();
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (
      changes.ids && !changes.ids.isFirstChange() ||
      changes.items && !changes.items.isFirstChange() ||
      changes.objectsList && !changes.objectsList.isFirstChange()
    ) {
      this._initData();
    }
  }

  onOpenDialog(event) {
    this.commonsDialogService.displayEntityLinksList(this.state, this.items, this.permission, event);
  }

  private _initData() {
    if (this.ids) {
      this.items = this.ids.map(id => {
        return {
          id: id
        }
      })
    }

    if (_.get(this.items, 'length')) {

      this.viewItems = this.maxDisplay ? _.filter(this.items, (item, index: number) => {
        return index < this.maxDisplay;
      }) : this.items;

      this.extraItems = this.items.slice(this.maxDisplay);

    }
  }


}

angular
  .module('bringoz.admin.commons')
  .component('bringozItemsLinkList', {
    bindings: {
      state: '<',
      permission: '<?',
      ids: '<?',
      items: '<?',
      objectsList: '<?',
      maxDisplay: '<?'
    },
    template: require('./bringoz-items-link-list.html').default,
    controller: BringozItemsLinkListComponent
  });
